import type { FC } from "react"
import { Trans } from "react-i18next"
import type { Supplier, Highlight, Document } from "../models/dashboard"

interface RightSidebarProps {
  suppliers: Supplier[]
  highlights: Highlight[]
  commercials: Highlight[]
  documents: Document[]
}

const RightSidebar: FC<RightSidebarProps> = ({ suppliers, highlights, commercials, documents }) => {
  const renderImageBox = (items: { id: number; link: string; image: string | null }[], titleKey: string) => {
    if (items.length === 0) return null
    return (
      <div className="bg-white shadow rounded-lg overflow-hidden">
        <div className="bg-blue-500 text-white px-4 py-2 font-medium text-sm" style={{ backgroundColor: "var(--secondary-color)" }}>
          <Trans i18nKey={titleKey} />
        </div>
        <div className="p-4 space-y-3">
          {items.map((item) =>
            item.image ? (
              <a
                key={item.id}
                href={item.link}
                target="_blank"
                rel="noopener noreferrer"
                className="block"
              >
                <img
                  src={item.image}
                  alt=""
                  className="w-full h-auto rounded"
                />
              </a>
            ) : null
          )}
        </div>
      </div>
    )
  }

  return (
    <div className="space-y-4">
      {suppliers.length > 0 && (
        <div className="bg-white shadow rounded-lg overflow-hidden">
          <div className="bg-blue-500 text-white px-4 py-2 font-medium text-sm" style={{ backgroundColor: "var(--secondary-color)" }}>
            <Trans i18nKey="dashboard.widgets.campanhas" />
          </div>
          <div className="p-4 space-y-3">
            {suppliers.map((supplier) =>
              supplier.image ? (
                <a
                  key={supplier.id}
                  href={supplier.link}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="block"
                >
                  <img src={supplier.image} alt={supplier.description} className="w-full h-auto rounded" />
                </a>
              ) : null
            )}
          </div>
        </div>
      )}

      {renderImageBox(highlights, "dashboard.widgets.destaques")}
      {renderImageBox(commercials, "dashboard.widgets.comercial")}

      {documents.length > 0 && (
        <div className="bg-white shadow rounded-lg overflow-hidden">
          <div className="bg-blue-500 text-white px-4 py-2 font-medium text-sm" style={{ backgroundColor: "var(--secondary-color)" }}>
            <Trans i18nKey="dashboard.widgets.documents" />
          </div>
          <div className="divide-y divide-gray-100">
            {documents.map((doc) => (
              <a
                key={doc.id}
                href={doc.url}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-3 px-4 py-3 hover:bg-gray-50"
              >
                <i className="fa fa-file-text-o text-gray-400 text-lg" />
                <div className="min-w-0 flex-1">
                  <p className="text-sm font-medium text-gray-900 truncate">{doc.name}</p>
                  {doc.description && (
                    <p className="text-xs text-gray-400 truncate">{doc.description}</p>
                  )}
                </div>
              </a>
            ))}
          </div>
        </div>
      )}
    </div>
  )
}

export default RightSidebar